import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PlayerModalComponent } from '../../../alert/player-modal/player-modal.component';
import { BettingServiceService } from "../../../../services/betting_service/betting-service.service";
import { CommonServiceService } from '../../../../services/common_service/common-service.service';
import { interval, Subscription } from 'rxjs';
import {betCategories} from '../virtual/virtual-categories'
import { meetingData_pObj } from '../../../../services/payload/meetingData_pobj';
import { StmgService } from '../../../../services/state_Management/stmg.service';
import { AlertController } from '@ionic/angular';
import { AlertComponent } from '../../../../components/alert/alert.component';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-track-side',
  templateUrl: './track-side.component.html',
  styleUrls: ['./track-side.component.scss'],
})
export class TrackSideComponent implements OnInit {
  videoPopup: HTMLIonModalElement;

  constructor(public modalController: ModalController, public betting_service: BettingServiceService,public translate:TranslateService,
    public common_service: CommonServiceService,private stmgService:StmgService,public alertController: AlertController,) { }

  mySubscription: Subscription;
  all_data: any;
  meeting_data:any;
  video_url='';
  is_logged = false;

  selectedBetCategory:any;
  selectedMeeting : any;

  viewSelectionBlock : boolean=false;

  ngOnInit() {
    this.viewSelectionBlock = false;
    this.stmgService.cast_clickStatus.subscribe(clicked => this.viewSelectionBlock = clicked);

    this.getMeetingData();
    this.get_trackside_results();
    
    //run every 5 seconds
    this.mySubscription = interval(5000).subscribe((x => {
      this.getMeetingData();
      this.get_trackside_results();

    }));

    this.stmgService.is_logged_status.subscribe(message =>
      this.is_logged = message
    );


  }

  get_trackside_results(){
    this.betting_service.getTrackSideResult().subscribe(
      (data) => {
        this.all_data = data;
        this.all_data.reverse();       
      },
      (error) => {
        //console.log(error);
      }
    );
  }


  getMeetingData(){
    let meetingPayload = new meetingData_pObj();
    meetingPayload.country = "AU";
    meetingPayload.date = this.common_service.getCurrentDateTime();
    meetingPayload.filter = 1;
    meetingPayload.inplay = false;
    meetingPayload.sport = "VR";

    this.betting_service.getMeetingData(meetingPayload).subscribe(data =>{
      //console.log(data['payload'][0].eventLightDTOs);
      this.meeting_data=data['payload'][0].eventLightDTOs;
    },(error)=>{
    
    });
  }


  viewRaceDetails(d:any) {
    this.viewSelectionBlock = true;
    this.selectedMeeting = d;
  }



  open_player() {
    if (this.is_logged){
      this.betting_service.getTrackVideoUrl(this.common_service.getToken()).subscribe(
        (data) => {
          //open only one popup
          if(!this.videoPopup || this.videoPopup==null){
            this.openVideoPopup(data); 
          }
        },
        (error) => {
          //console.log(error);
        }
      );
  

    }
    else{
      let alertTitle:string;
      let alertDesc:string;
      this.translate.get('ALERTS.LOGTO_VIDEO.TITLE').subscribe((res: string) => {
        alertTitle=res;
      });
      this.translate.get('ALERTS.LOGTO_VIDEO.DESC').subscribe((res: string) => {
        alertDesc=res;
      });
      let alert = new AlertComponent(this.alertController);
      alert.loginSuccessAlert("", alertTitle, alertDesc);
    }

    
  }

  async openVideoPopup(data){
    const modal = await this.modalController.create({
      component: PlayerModalComponent,
      cssClass: 'customPopup',
      componentProps:{videoUrl:data.url}
    });
    this.videoPopup=modal;
    modal.onDidDismiss().then(data=>{
      this.videoPopup=null
    })
    return await modal.present();
  }

  //stop the 5 seconds loop
  ngOnDestroy() {
    this.mySubscription.unsubscribe();
  }




}
